import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import { useSelector } from "react-redux";

const FilterData = ({
  currentRole,
  setCurrentRole,
  userRoles,
  currentProject,
  setCurrentProject,
  searchTerm,
  setSearchTerm,
  projectList = [],
}) => {
  const { role } = useSelector((state) => state.auth);

  return (
    <div>
      <div className="filter-wrapper">
        <Row>
          <Col md="6">
            <Form.Control
              type="text"
              name="userSearch"
              value={searchTerm}
              placeholder="Search by name..."
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Col>
          <Col>
            <Form.Select
              name="role"
              value={currentRole}
              onChange={(e) => setCurrentRole(e.target.value)}
            >
              <option value="">All Roles</option>
              {userRoles.map((user, index) => (
                <option key={index} value={user.role}>
                  {user.role}
                </option>
              ))}
            </Form.Select>
          </Col>
          {role === "manager" && role ===
              "staff" && (
                <Col>
                  <Form.Select
                    name="project"
                    value={currentProject}
                    onChange={(e) => setCurrentProject(e.target.value)}
                  >
                    <option value="">All Projects</option>
                    {projectList?.map((project) => (
                      <option key={project.id} value={project.projectName}>
                        {project.projectName}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
              )}
        </Row>
      </div>
    </div>
  );
};

export default FilterData;
